import React from "react";
import { ImportStatusModal } from "../../../ImportStatusModal";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const ImportStatusModalWrapper: React.FC = () => {
  const { modals } = useClarificationsRegisterContext();
  const { isImportModalOpen, setIsImportModalOpen, importResult } = modals;

  return (
    <ImportStatusModal
      isOpen={isImportModalOpen}
      onClose={() => setIsImportModalOpen(false)}
      result={importResult}
    />
  );
};
